// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3wIxr","normal":"Button_normal__3hNCN","small":"Button_small__uTNB2","large":"Button_large__2KPb2","straight":"Button_straight__3zhD-"};